






















import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Company } from '../store/company'
import Add from './Add.vue'
import Detail from './Detail.vue'
const company = namespace('company')

@Component({ components: { Add, Detail } })
export default class CompanyView extends Vue {
  @company.Getter companies!: Company[]
  @company.Action loadCompanies!: () => void
  @company.Action getCompany!: (id: number) => Company
  company: Company | null = null
  dialog = false

  created() {
    this.loadCompanies()
  }

  async select(id: number) {
    this.company = await this.getCompany(id)
    this.dialog = true
  }
}
